import axios from "./axios"

function search(search) {
    return axios().get("/currencies-search", { params: {
        search
    } })
}

export default {
    search
}